import { render, staticRenderFns } from "./case-export.vue?vue&type=template&id=4d4c49c1&scoped=true"
import script from "./case-export.vue?vue&type=script&lang=ts"
export * from "./case-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c49c1",
  null
  
)

export default component.exports